import React from 'react';

import IconArrow from '@components/Images/IconArrow';
import IconTI from '@components/Images/Rebranding/IconTI';
import { useEventTracking } from '@hooks';
import { ClickTarget, TrackingLocation, click } from '@tracking';

interface DownloadAppProps {
  contentId?: string | number;
}

const DownloadApp = ({ contentId }: DownloadAppProps) => {
  const { trackEvent } = useEventTracking({
    location: TrackingLocation.Paywall,
    contentId: contentId,
  });

  const handleTrackingClick = () => {
    trackEvent(click({ clickTarget: ClickTarget.DownloadApp }));
  };

  return (
    <a
      className="flex w-full items-center justify-center gap-8 bg-grayscale-charcoal px-36 py-12 text-center text-button-lg font-medium text-white sm:hidden dark:bg-[var(--light-grayscale-charcoal)]"
      href="https://theinformation.onelink.me/6IaG/3stnun15"
      data-testid="download-app"
      onClickCapture={handleTrackingClick}
    >
      <span className="flex h-32 w-32 items-center justify-center rounded-4 bg-primary-magenta">
        <IconTI className="h-24 text-white" />
      </span>
      Download the App
      <IconArrow className="ml-8 w-[17px] rotate-180 text-primary-magenta" />
    </a>
  );
};

export default DownloadApp;
